// Navigation item type definition
import {CalendarDays, LucideIcon, Tags, Zap} from "lucide-react";

export interface NavItem {
  name: string;
  icon: LucideIcon; // Using ComponentType for icon components
  path: string;
}

// Define the navigation items
export const navItems: NavItem[] = [
  { name: 'Calendar', icon: CalendarDays, path: '/calendar' },
  { name: 'Activities', icon: Zap, path: '/activities' },
  { name: 'Categories', icon: Tags, path: '/categories' },
];
